// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode styles - applied when body has class 'dark-mode' */

:root {
  --dm-bg: #0f1720;
  --dm-surface: #111827;
  --dm-muted: #9ca3af;
  --dm-text: #e5e7eb;
  --dm-accent: #60a5fa;
}

html:has(body.dark-mode),
body.dark-mode {
  background-color: var(--dm-bg) !important;
  color: var(--dm-text) !important;
}

body.dark-mode #root,
body.dark-mode .full-screen-div {
  background-color: var(--dm-bg) !important;
  color: var(--dm-text) !important;
}

/* Surfaces */
body.dark-mode .card,
body.dark-mode .bg-light,
body.dark-mode .container,
body.dark-mode .container-fluid {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
  border-color: rgba(255,255,255,0.04) !important;
}

/* Navbar */
body.dark-mode .navbar,
body.dark-mode nav {
  background-color: rgba(17,24,39,0.9) !important;
  color: var(--dm-text) !important;
}

/* Links */
body.dark-mode a,
body.dark-mode .nav-link {
  color: var(--dm-text) !important;
}

body.dark-mode a:hover,
body.dark-mode .nav-link:hover {
  color: var(--dm-accent) !important;
}

/* Buttons */
body.dark-mode .btn,
body.dark-mode button {
  background-color: transparent !important;
  color: var(--dm-text) !important;
  border-color: rgba(255,255,255,0.06) !important;
}

/* Forms */
body.dark-mode input,
body.dark-mode textarea,
body.dark-mode select,
body.dark-mode .form-control {
  background-color: rgba(255,255,255,0.03) !important;
  color: var(--dm-text) !important;
  border: 1px solid rgba(255,255,255,0.06) !important;
}

/* Tables */
body.dark-mode table,
body.dark-mode .table {
  color: var(--dm-text) !important;
}

/* Footer */
body.dark-mode footer,
body.dark-mode .footer {
  background-color: transparent !important;
  color: var(--dm-muted) !important;
}

/* Tables: garantir fundo escuro e linhas legíveis */
body.dark-mode table,
body.dark-mode .table {
  background-color: transparent !important;
  color: var(--dm-text) !important;
  border-collapse: separate !important;
}

body.dark-mode thead th,
body.dark-mode .table thead th {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
  border-bottom: 2px solid rgba(255,255,255,0.06) !important;
  font-weight: 700 !important;
  text-transform: none !important;
  padding: 10px 12px !important;
}

body.dark-mode tbody tr,
body.dark-mode .table tbody tr {
  background-color: rgba(255,255,255,0.01) !important;
  color: var(--dm-text) !important;
}

/* Garantir que células tenham contraste suficiente */
body.dark-mode td,
body.dark-mode th {
  background-color: transparent !important;
  color: var(--dm-text) !important;
  padding: 8px 12px !important;
}

/* Caso componentes utilizem classes bootstrap de cabeçalho */
body.dark-mode .table thead tr th.bg-light,
body.dark-mode .table thead tr th.bg-white {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
}

/* Sobrescrever .table-primary (Bootstrap) no modo escuro */
body.dark-mode thead.table-primary,
body.dark-mode thead.table-primary th,
body.dark-mode thead.table-primary tr th,
body.dark-mode thead.table-primary tr {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
}

/* Inputs e placeholder: garantir visibilidade */
body.dark-mode .form-control {
  background-color: rgba(255,255,255,0.02) !important;
  color: var(--dm-text) !important;
  border: 1px solid rgba(255,255,255,0.04) !important;
}

body.dark-mode .form-control::placeholder {
  color: rgba(229,231,235,0.6) !important; /* lighter placeholder */
}

/* Botões primários/segundoários: tornar legíveis no dark mode */
body.dark-mode .btn-primary {
  background-color: #2563eb !important; /* slightly muted blue */
  border-color: #1d4ed8 !important;
  color: #fff !important;
}

body.dark-mode .btn-secondary,
body.dark-mode .btn-outline-secondary {
  background-color: rgba(255,255,255,0.03) !important;
  color: var(--dm-text) !important;
  border-color: rgba(255,255,255,0.06) !important;
}


body.dark-mode .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255,255,255,0.02) !important;
}

body.dark-mode .table-hover tbody tr:hover {
  background-color: rgba(96,165,250,0.08) !important; /* accent hover */
}

/* Modal header: usar superfície escura consistente */
body.dark-mode .modal-header {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
  border-bottom: 1px solid rgba(255,255,255,0.04) !important;
}

body.dark-mode .modal-title {
  color: var(--dm-text) !important;
}

/* Footer bar / versão */
body.dark-mode .footer-wrapper,
body.dark-mode .footer {
  background-color: transparent !important;
  color: var(--dm-muted) !important;
}

/* Scrollbar escura */
body.dark-mode ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

body.dark-mode ::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.02);
}

body.dark-mode ::-webkit-scrollbar-thumb {
  background-color: rgba(255,255,255,0.06);
  border-radius: 10px;
  border: 2px solid rgba(0,0,0,0);
}

/* Firefox scrollbar */
body.dark-mode {
  scrollbar-color: rgba(255,255,255,0.06) rgba(255,255,255,0.02);
  scrollbar-width: thin;
}

/* Forçar que toda a janela e elementos de nível root usem o background escuro
   (aplica somente quando a classe \`dark-mode\` estiver presente no body) */
body.dark-mode,
body.dark-mode #root,
body.dark-mode .app,
body.dark-mode .full-screen-div,
body.dark-mode .page-wrapper,
body.dark-mode .content-wrapper,
body.dark-mode .main-content,
body.dark-mode .page-content {
  background-color: var(--dm-bg) !important;
  color: var(--dm-text) !important;
  min-height: 100vh !important;
}

/* Sobrescrever bg-light/bg-white e áreas fixas que permaneciam claras */
body.dark-mode .bg-light,
body.dark-mode .bg-white,
body.dark-mode .card,
body.dark-mode .container,
body.dark-mode .container-fluid,
body.dark-mode header,
body.dark-mode .header,
body.dark-mode footer,
body.dark-mode .footer {
  background-color: transparent !important;
  color: var(--dm-text) !important;
}

/* Dropdowns, selects e menus */
body.dark-mode .dropdown-menu,
body.dark-mode .dropdown-menu.show,
body.dark-mode .dropdown-item {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
}

/* Ajustes para selects (react-select / bootstrap select / native) */
body.dark-mode select,
body.dark-mode .form-select,
body.dark-mode .select,
body.dark-mode .dropdown-toggle,
body.dark-mode .ui-select {
  background-color: rgba(255,255,255,0.02) !important;
  color: var(--dm-text) !important;
  border: 1px solid rgba(255,255,255,0.04) !important;
}

body.dark-mode select option,
body.dark-mode .form-select option {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
}

/* Forçar o menu do select de componentes customizados (ex.: react-select) */
body.dark-mode .react-select__menu,
body.dark-mode .react-select__menu-list,
body.dark-mode .Select-menu-outer,
body.dark-mode .select-menu {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
  border: 1px solid rgba(255,255,255,0.04) !important;
}

/* Items do menu do select */
body.dark-mode .react-select__option,
body.dark-mode .Select-option,
body.dark-mode .dropdown-item {
  color: var(--dm-text) !important;
  background-color: transparent !important;
}

body.dark-mode .react-select__option--is-focused,
body.dark-mode .Select-option.is-focused,
body.dark-mode .dropdown-item:hover {
  background-color: rgba(255,255,255,0.03) !important;
  color: var(--dm-text) !important;
}

/* Placeholders e caret */
body.dark-mode .form-select::placeholder,
body.dark-mode .select::placeholder {
  color: rgba(229,231,235,0.5) !important;
}

/* Dropdown arrow contrast */
body.dark-mode .dropdown-toggle::after,
body.dark-mode .form-select::after {
  color: var(--dm-text) !important;
}

/* Sticky top header bars (navbars) */
body.dark-mode .navbar,
body.dark-mode .sticky-top,
body.dark-mode .navbar-dark,
body.dark-mode nav {
  background-color: var(--dm-surface) !important;
  background: none !important;
  color: var(--dm-text) !important;
}

/* Forçar override quando navbar usa inline background/gradient */
body.dark-mode .navbar[style],
body.dark-mode .navbar.fixed-top,
body.dark-mode .navbar.fixed-top .container-fluid {
  background-color: var(--dm-surface) !important;
  background-image: none !important;
  background: var(--dm-surface) !important;
  color: var(--dm-text) !important;
}

/* Links e itens dentro da navbar */
body.dark-mode .navbar a,
body.dark-mode .navbar .nav-link,
body.dark-mode .navbar .navbar-brand,
body.dark-mode .navbar .user-info {
  color: var(--dm-text) !important;
}

/* Footer fixed wrapper and footer element */
body.dark-mode .footer-wrapper {
  background-color: transparent !important;
}

body.dark-mode footer.footer,
body.dark-mode .footer {
  background-color: var(--dm-surface) !important;
  color: var(--dm-muted) !important;
  border-top: 1px solid rgba(255,255,255,0.04) !important;
}

/* Ensure container inside footer adapts */
body.dark-mode footer.footer .container,
body.dark-mode .footer .container {
  background-color: transparent !important;
  color: var(--dm-muted) !important;
}

/* Ensure modal backdrop is darker */
body.dark-mode .modal-backdrop {
  background-color: rgba(0,0,0,0.6) !important;
}

/* Modal content and body styling for dark mode */
body.dark-mode .modal-content {
  background-color: var(--dm-surface) !important;
  color: var(--dm-text) !important;
  border: 1px solid rgba(255,255,255,0.04) !important;
  box-shadow: 0 10px 30px rgba(2,6,23,0.6) !important;
}

body.dark-mode .modal-body {
  background-color: transparent !important;
  color: var(--dm-text) !important;
}

body.dark-mode .modal-footer {
  background-color: rgba(255,255,255,0.01) !important;
  border-top: 1px solid rgba(255,255,255,0.04) !important;
}

/* Remove white backgrounds inside modal (e.g., components using bg-white) */
body.dark-mode .modal-content .bg-white,
body.dark-mode .modal-content .card,
body.dark-mode .modal-content .container,
body.dark-mode .modal-content .container-fluid {
  background: transparent !important;
  color: var(--dm-text) !important;
}

/* Buttons inside modal footer */
body.dark-mode .modal-footer .btn,
body.dark-mode .modal-footer .btn-primary,
body.dark-mode .modal-footer .btn-secondary {
  color: var(--dm-text) !important;
}

/* Inputs in modals already inherit .form-control rules, but ensure placeholders are visible */
body.dark-mode .modal .form-control::placeholder {
  color: rgba(229,231,235,0.6) !important;
}

/* Tables container background */
body.dark-mode .table-responsive {
  background-color: transparent !important;
}

/* Linha selecionada: garantir contraste no modo escuro */
body.dark-mode .table tbody tr.table-active,
body.dark-mode .table tbody tr.active,
body.dark-mode .table tbody tr.selected,
body.dark-mode .table .table-active,
body.dark-mode .table .selected {
  background-color: rgba(96,165,250,0.12) !important; /* soft blue */
  color: #000000 !important; /* texto preto para contraste */
  font-weight: 600 !important;
}

body.dark-mode .table tbody tr.table-active td,
body.dark-mode .table tbody tr.active td,
body.dark-mode .table tbody tr.selected td {
  color: #000000 !important;
}

/* Ajustes para badges/labels dentro da linha selecionada para não perder leitura */
body.dark-mode .table tbody tr.selected .badge,
body.dark-mode .table tbody tr.selected .label,
body.dark-mode .table tbody tr.selected .btn {
  filter: none !important;
  color: #000000 !important;
}

/* Hover combinado com seleção */
body.dark-mode .table tbody tr.selected:hover,
body.dark-mode .table tbody tr.table-active:hover {
  background-color: rgba(96,165,250,0.16) !important;
}

/* Very high-specificity fallback to override other compiled styles */
body.dark-mode table.table tbody tr.selected,
body.dark-mode table.table tbody tr.selected td,
body.dark-mode table.table tbody tr.selected th,
body.dark-mode table.table tbody tr.selected td *,
body.dark-mode table.table tbody tr.selected th * {
  color: #000000 !important;
  fill: #000000 !important;
}

/* Ensure anchor/text inside selected row are black */
body.dark-mode table.table tbody tr.selected a,
body.dark-mode table.table tbody tr.selected span,
body.dark-mode table.table tbody tr.selected p,
body.dark-mode table.table tbody tr.selected div {
  color: #000000 !important;
}

/* Additional brute-force overrides for common utility classes inside selected rows */
body.dark-mode table.table tbody tr.selected .text-white,
body.dark-mode table.table tbody tr.selected .text-muted,
body.dark-mode table.table tbody tr.selected .badge,
body.dark-mode table.table tbody tr.selected .btn,
body.dark-mode table.table tbody tr.selected .btn *,
body.dark-mode table.table tbody tr.selected .badge *,
body.dark-mode table.table tbody tr.selected .dropdown-toggle {
  color: #000000 !important;
  background-color: transparent !important;
  -webkit-text-fill-color: #000000 !important;
}

/* Inline SVG icons inside selected rows */
body.dark-mode table.table tbody tr.selected svg {
  fill: #000000 !important;
}

/* If the row is marked via .table-active class on ancestor tbody */
body.dark-mode table.table tbody.table-active tr,
body.dark-mode table.table tbody.table-active tr td,
body.dark-mode table.table tbody.table-active tr * {
  color: #000000 !important;
}

/* Close (X) button visibility in dark mode */
body.dark-mode .btn-close,
body.dark-mode .close {
  background-image: none !important;
  width: 34px !important;
  height: 34px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: var(--dm-text) !important;
  border: none !important;
  opacity: 0.95 !important;
}

body.dark-mode .btn-close::before,
body.dark-mode .close::before {
  content: '✕' !important;
  font-size: 16px !important;
  color: var(--dm-text) !important;
  line-height: 1 !important;
}

body.dark-mode .btn-close:hover,
body.dark-mode .btn-close:focus,
body.dark-mode .close:hover,
body.dark-mode .close:focus {
  background-color: rgba(255,255,255,0.06) !important;
  color: var(--dm-text) !important;
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(96,165,250,0.10) !important;
}

/* Ensure close button in modal header aligns and contrasts */
body.dark-mode .modal-header .btn-close {
  margin: 6px !important;
}

/* Explicit overrides for specific contexts to beat compiled bootstrap/public CSS */
body.dark-mode .modal .btn-close,
body.dark-mode .offcanvas .btn-close,
body.dark-mode .toast .btn-close,
body.dark-mode .alert .btn-close,
body.dark-mode .dropdown .btn-close,
body.dark-mode .btn-close.btn-close-white {
  background-image: none !important;
  background: transparent !important;
  color: var(--dm-text) !important;
  border: none !important;
}

/* If bootstrap forces an SVG background, replace it with a white SVG via data URI to ensure visibility */
body.dark-mode .btn-close[style],
body.dark-mode .modal-header .btn-close[style] {
  background-image: none !important;
  background: transparent !important;
  background-size: none !important;
  background-repeat: none !important;
  background-position: center !important;
}

/* Ensure hover/focus remain visible */
body.dark-mode .btn-close:hover,
body.dark-mode .btn-close:focus {
  opacity: 1 !important;
  background-color: rgba(255,255,255,0.06) !important;
  box-shadow: 0 0 0 4px rgba(96,165,250,0.08) !important;
}

/* Melhor contraste entre divs com bordas */
body.dark-mode .card,
body.dark-mode .panel,
body.dark-mode .box,
body.dark-mode .bordered,
body.dark-mode .border,
body.dark-mode .list-group-item,
body.dark-mode .form-control,
body.dark-mode .table,
body.dark-mode .table-responsive,
body.dark-mode .container,
body.dark-mode .container-fluid {
  border: 1px solid rgba(255,255,255,0.06) !important;
  background-color: rgba(255,255,255,0.01) !important;
}

/* Reforçar classes de borda específicas */
body.dark-mode .border-top,
body.dark-mode .border-bottom,
body.dark-mode .border-left,
body.dark-mode .border-right {
  border-color: rgba(255,255,255,0.06) !important;
}

/* Painéis internos e containers com separação mais visível */
body.dark-mode .panel + .panel,
body.dark-mode .card + .card,
body.dark-mode .form-group {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

/* Garantir que títulos dentro de caixas contrastem */
body.dark-mode .card .card-header,
body.dark-mode .panel .panel-heading {
  background-color: rgba(255,255,255,0.012) !important;
  color: var(--dm-text) !important;
  border-bottom: 1px solid rgba(255,255,255,0.04) !important;
}


`, "",{"version":3,"sources":["webpack://./src/service/css/DarkMode.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;;EAEE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA,aAAa;AACb;;;;EAIE,8CAA8C;EAC9C,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,WAAW;AACX;;EAEE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA,UAAU;AACV;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,YAAY;AACZ;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,UAAU;AACV;;;;EAIE,mDAAmD;EACnD,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA,WAAW;AACX;;EAEE,gCAAgC;AAClC;;AAEA,WAAW;AACX;;EAEE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,oDAAoD;AACpD;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;EAC9C,gCAAgC;EAChC,0DAA0D;EAC1D,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;;EAEE,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,6DAA6D;AAC7D;;EAEE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,2DAA2D;AAC3D;;;;EAIE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,mDAAmD;EACnD,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,uCAAuC,EAAE,wBAAwB;AACnE;;AAEA,gEAAgE;AAChE;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,mDAAmD;EACnD,gCAAgC;EAChC,+CAA+C;AACjD;;;AAGA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD,EAAE,iBAAiB;AACvE;;AAEA,qDAAqD;AACrD;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;;EAEE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,8DAA8D;EAC9D,qBAAqB;AACvB;;AAEA;0EAC0E;AAC1E;;;;;;;;EAQE,yCAAyC;EACzC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;;;;;;;;;EASE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;;;EAGE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,oEAAoE;AACpE;;;;;EAKE,mDAAmD;EACnD,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;;EAEE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,4EAA4E;AAC5E;;;;EAIE,8CAA8C;EAC9C,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;;;EAGE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;;EAGE,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;;EAEE,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;;EAEE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;;;;EAIE,8CAA8C;EAC9C,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,iEAAiE;AACjE;;;EAGE,8CAA8C;EAC9C,iCAAiC;EACjC,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;;;;EAIE,gCAAgC;AAClC;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,8CAA8C;EAC9C,iCAAiC;EACjC,uDAAuD;AACzD;;AAEA,0CAA0C;AAC1C;;EAEE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,oCAAoC;AACpC;EACE,4CAA4C;AAC9C;;AAEA,iDAAiD;AACjD;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,uDAAuD;AACzD;;AAEA,4EAA4E;AAC5E;;;;EAIE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;;;EAGE,gCAAgC;AAClC;;AAEA,8FAA8F;AAC9F;EACE,uCAAuC;AACzC;;AAEA,gCAAgC;AAChC;EACE,wCAAwC;AAC1C;;AAEA,yDAAyD;AACzD;;;;;EAKE,kDAAkD,EAAE,cAAc;EAClE,yBAAyB,EAAE,+BAA+B;EAC1D,2BAA2B;AAC7B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;;;EAGE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;EAEE,kDAAkD;AACpD;;AAEA,qEAAqE;AACrE;;;;;EAKE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;;;;EAIE,yBAAyB;AAC3B;;AAEA,qFAAqF;AACrF;;;;;;;EAOE,yBAAyB;EACzB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;;;EAGE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,kCAAkC;EAClC,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;EAIE,mDAAmD;EACnD,gCAAgC;EAChC,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;;;;;;EAME,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,yGAAyG;AACzG;;EAEE,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,sCAAsC;AACtC;;EAEE,qBAAqB;EACrB,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA,2CAA2C;AAC3C;;;;;;;;;;;EAWE,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA,0CAA0C;AAC1C;;;;EAIE,+CAA+C;AACjD;;AAEA,6DAA6D;AAC7D;;;EAGE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,qDAAqD;AACrD;;EAEE,oDAAoD;EACpD,gCAAgC;EAChC,0DAA0D;AAC5D","sourcesContent":["/* Dark Mode styles - applied when body has class 'dark-mode' */\n\n:root {\n  --dm-bg: #0f1720;\n  --dm-surface: #111827;\n  --dm-muted: #9ca3af;\n  --dm-text: #e5e7eb;\n  --dm-accent: #60a5fa;\n}\n\nhtml:has(body.dark-mode),\nbody.dark-mode {\n  background-color: var(--dm-bg) !important;\n  color: var(--dm-text) !important;\n}\n\nbody.dark-mode #root,\nbody.dark-mode .full-screen-div {\n  background-color: var(--dm-bg) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Surfaces */\nbody.dark-mode .card,\nbody.dark-mode .bg-light,\nbody.dark-mode .container,\nbody.dark-mode .container-fluid {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n  border-color: rgba(255,255,255,0.04) !important;\n}\n\n/* Navbar */\nbody.dark-mode .navbar,\nbody.dark-mode nav {\n  background-color: rgba(17,24,39,0.9) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Links */\nbody.dark-mode a,\nbody.dark-mode .nav-link {\n  color: var(--dm-text) !important;\n}\n\nbody.dark-mode a:hover,\nbody.dark-mode .nav-link:hover {\n  color: var(--dm-accent) !important;\n}\n\n/* Buttons */\nbody.dark-mode .btn,\nbody.dark-mode button {\n  background-color: transparent !important;\n  color: var(--dm-text) !important;\n  border-color: rgba(255,255,255,0.06) !important;\n}\n\n/* Forms */\nbody.dark-mode input,\nbody.dark-mode textarea,\nbody.dark-mode select,\nbody.dark-mode .form-control {\n  background-color: rgba(255,255,255,0.03) !important;\n  color: var(--dm-text) !important;\n  border: 1px solid rgba(255,255,255,0.06) !important;\n}\n\n/* Tables */\nbody.dark-mode table,\nbody.dark-mode .table {\n  color: var(--dm-text) !important;\n}\n\n/* Footer */\nbody.dark-mode footer,\nbody.dark-mode .footer {\n  background-color: transparent !important;\n  color: var(--dm-muted) !important;\n}\n\n/* Tables: garantir fundo escuro e linhas legíveis */\nbody.dark-mode table,\nbody.dark-mode .table {\n  background-color: transparent !important;\n  color: var(--dm-text) !important;\n  border-collapse: separate !important;\n}\n\nbody.dark-mode thead th,\nbody.dark-mode .table thead th {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n  border-bottom: 2px solid rgba(255,255,255,0.06) !important;\n  font-weight: 700 !important;\n  text-transform: none !important;\n  padding: 10px 12px !important;\n}\n\nbody.dark-mode tbody tr,\nbody.dark-mode .table tbody tr {\n  background-color: rgba(255,255,255,0.01) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Garantir que células tenham contraste suficiente */\nbody.dark-mode td,\nbody.dark-mode th {\n  background-color: transparent !important;\n  color: var(--dm-text) !important;\n  padding: 8px 12px !important;\n}\n\n/* Caso componentes utilizem classes bootstrap de cabeçalho */\nbody.dark-mode .table thead tr th.bg-light,\nbody.dark-mode .table thead tr th.bg-white {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Sobrescrever .table-primary (Bootstrap) no modo escuro */\nbody.dark-mode thead.table-primary,\nbody.dark-mode thead.table-primary th,\nbody.dark-mode thead.table-primary tr th,\nbody.dark-mode thead.table-primary tr {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Inputs e placeholder: garantir visibilidade */\nbody.dark-mode .form-control {\n  background-color: rgba(255,255,255,0.02) !important;\n  color: var(--dm-text) !important;\n  border: 1px solid rgba(255,255,255,0.04) !important;\n}\n\nbody.dark-mode .form-control::placeholder {\n  color: rgba(229,231,235,0.6) !important; /* lighter placeholder */\n}\n\n/* Botões primários/segundoários: tornar legíveis no dark mode */\nbody.dark-mode .btn-primary {\n  background-color: #2563eb !important; /* slightly muted blue */\n  border-color: #1d4ed8 !important;\n  color: #fff !important;\n}\n\nbody.dark-mode .btn-secondary,\nbody.dark-mode .btn-outline-secondary {\n  background-color: rgba(255,255,255,0.03) !important;\n  color: var(--dm-text) !important;\n  border-color: rgba(255,255,255,0.06) !important;\n}\n\n\nbody.dark-mode .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255,255,255,0.02) !important;\n}\n\nbody.dark-mode .table-hover tbody tr:hover {\n  background-color: rgba(96,165,250,0.08) !important; /* accent hover */\n}\n\n/* Modal header: usar superfície escura consistente */\nbody.dark-mode .modal-header {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n  border-bottom: 1px solid rgba(255,255,255,0.04) !important;\n}\n\nbody.dark-mode .modal-title {\n  color: var(--dm-text) !important;\n}\n\n/* Footer bar / versão */\nbody.dark-mode .footer-wrapper,\nbody.dark-mode .footer {\n  background-color: transparent !important;\n  color: var(--dm-muted) !important;\n}\n\n/* Scrollbar escura */\nbody.dark-mode ::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\nbody.dark-mode ::-webkit-scrollbar-track {\n  background: rgba(255,255,255,0.02);\n}\n\nbody.dark-mode ::-webkit-scrollbar-thumb {\n  background-color: rgba(255,255,255,0.06);\n  border-radius: 10px;\n  border: 2px solid rgba(0,0,0,0);\n}\n\n/* Firefox scrollbar */\nbody.dark-mode {\n  scrollbar-color: rgba(255,255,255,0.06) rgba(255,255,255,0.02);\n  scrollbar-width: thin;\n}\n\n/* Forçar que toda a janela e elementos de nível root usem o background escuro\n   (aplica somente quando a classe `dark-mode` estiver presente no body) */\nbody.dark-mode,\nbody.dark-mode #root,\nbody.dark-mode .app,\nbody.dark-mode .full-screen-div,\nbody.dark-mode .page-wrapper,\nbody.dark-mode .content-wrapper,\nbody.dark-mode .main-content,\nbody.dark-mode .page-content {\n  background-color: var(--dm-bg) !important;\n  color: var(--dm-text) !important;\n  min-height: 100vh !important;\n}\n\n/* Sobrescrever bg-light/bg-white e áreas fixas que permaneciam claras */\nbody.dark-mode .bg-light,\nbody.dark-mode .bg-white,\nbody.dark-mode .card,\nbody.dark-mode .container,\nbody.dark-mode .container-fluid,\nbody.dark-mode header,\nbody.dark-mode .header,\nbody.dark-mode footer,\nbody.dark-mode .footer {\n  background-color: transparent !important;\n  color: var(--dm-text) !important;\n}\n\n/* Dropdowns, selects e menus */\nbody.dark-mode .dropdown-menu,\nbody.dark-mode .dropdown-menu.show,\nbody.dark-mode .dropdown-item {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Ajustes para selects (react-select / bootstrap select / native) */\nbody.dark-mode select,\nbody.dark-mode .form-select,\nbody.dark-mode .select,\nbody.dark-mode .dropdown-toggle,\nbody.dark-mode .ui-select {\n  background-color: rgba(255,255,255,0.02) !important;\n  color: var(--dm-text) !important;\n  border: 1px solid rgba(255,255,255,0.04) !important;\n}\n\nbody.dark-mode select option,\nbody.dark-mode .form-select option {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Forçar o menu do select de componentes customizados (ex.: react-select) */\nbody.dark-mode .react-select__menu,\nbody.dark-mode .react-select__menu-list,\nbody.dark-mode .Select-menu-outer,\nbody.dark-mode .select-menu {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n  border: 1px solid rgba(255,255,255,0.04) !important;\n}\n\n/* Items do menu do select */\nbody.dark-mode .react-select__option,\nbody.dark-mode .Select-option,\nbody.dark-mode .dropdown-item {\n  color: var(--dm-text) !important;\n  background-color: transparent !important;\n}\n\nbody.dark-mode .react-select__option--is-focused,\nbody.dark-mode .Select-option.is-focused,\nbody.dark-mode .dropdown-item:hover {\n  background-color: rgba(255,255,255,0.03) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Placeholders e caret */\nbody.dark-mode .form-select::placeholder,\nbody.dark-mode .select::placeholder {\n  color: rgba(229,231,235,0.5) !important;\n}\n\n/* Dropdown arrow contrast */\nbody.dark-mode .dropdown-toggle::after,\nbody.dark-mode .form-select::after {\n  color: var(--dm-text) !important;\n}\n\n/* Sticky top header bars (navbars) */\nbody.dark-mode .navbar,\nbody.dark-mode .sticky-top,\nbody.dark-mode .navbar-dark,\nbody.dark-mode nav {\n  background-color: var(--dm-surface) !important;\n  background: none !important;\n  color: var(--dm-text) !important;\n}\n\n/* Forçar override quando navbar usa inline background/gradient */\nbody.dark-mode .navbar[style],\nbody.dark-mode .navbar.fixed-top,\nbody.dark-mode .navbar.fixed-top .container-fluid {\n  background-color: var(--dm-surface) !important;\n  background-image: none !important;\n  background: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n}\n\n/* Links e itens dentro da navbar */\nbody.dark-mode .navbar a,\nbody.dark-mode .navbar .nav-link,\nbody.dark-mode .navbar .navbar-brand,\nbody.dark-mode .navbar .user-info {\n  color: var(--dm-text) !important;\n}\n\n/* Footer fixed wrapper and footer element */\nbody.dark-mode .footer-wrapper {\n  background-color: transparent !important;\n}\n\nbody.dark-mode footer.footer,\nbody.dark-mode .footer {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-muted) !important;\n  border-top: 1px solid rgba(255,255,255,0.04) !important;\n}\n\n/* Ensure container inside footer adapts */\nbody.dark-mode footer.footer .container,\nbody.dark-mode .footer .container {\n  background-color: transparent !important;\n  color: var(--dm-muted) !important;\n}\n\n/* Ensure modal backdrop is darker */\nbody.dark-mode .modal-backdrop {\n  background-color: rgba(0,0,0,0.6) !important;\n}\n\n/* Modal content and body styling for dark mode */\nbody.dark-mode .modal-content {\n  background-color: var(--dm-surface) !important;\n  color: var(--dm-text) !important;\n  border: 1px solid rgba(255,255,255,0.04) !important;\n  box-shadow: 0 10px 30px rgba(2,6,23,0.6) !important;\n}\n\nbody.dark-mode .modal-body {\n  background-color: transparent !important;\n  color: var(--dm-text) !important;\n}\n\nbody.dark-mode .modal-footer {\n  background-color: rgba(255,255,255,0.01) !important;\n  border-top: 1px solid rgba(255,255,255,0.04) !important;\n}\n\n/* Remove white backgrounds inside modal (e.g., components using bg-white) */\nbody.dark-mode .modal-content .bg-white,\nbody.dark-mode .modal-content .card,\nbody.dark-mode .modal-content .container,\nbody.dark-mode .modal-content .container-fluid {\n  background: transparent !important;\n  color: var(--dm-text) !important;\n}\n\n/* Buttons inside modal footer */\nbody.dark-mode .modal-footer .btn,\nbody.dark-mode .modal-footer .btn-primary,\nbody.dark-mode .modal-footer .btn-secondary {\n  color: var(--dm-text) !important;\n}\n\n/* Inputs in modals already inherit .form-control rules, but ensure placeholders are visible */\nbody.dark-mode .modal .form-control::placeholder {\n  color: rgba(229,231,235,0.6) !important;\n}\n\n/* Tables container background */\nbody.dark-mode .table-responsive {\n  background-color: transparent !important;\n}\n\n/* Linha selecionada: garantir contraste no modo escuro */\nbody.dark-mode .table tbody tr.table-active,\nbody.dark-mode .table tbody tr.active,\nbody.dark-mode .table tbody tr.selected,\nbody.dark-mode .table .table-active,\nbody.dark-mode .table .selected {\n  background-color: rgba(96,165,250,0.12) !important; /* soft blue */\n  color: #000000 !important; /* texto preto para contraste */\n  font-weight: 600 !important;\n}\n\nbody.dark-mode .table tbody tr.table-active td,\nbody.dark-mode .table tbody tr.active td,\nbody.dark-mode .table tbody tr.selected td {\n  color: #000000 !important;\n}\n\n/* Ajustes para badges/labels dentro da linha selecionada para não perder leitura */\nbody.dark-mode .table tbody tr.selected .badge,\nbody.dark-mode .table tbody tr.selected .label,\nbody.dark-mode .table tbody tr.selected .btn {\n  filter: none !important;\n  color: #000000 !important;\n}\n\n/* Hover combinado com seleção */\nbody.dark-mode .table tbody tr.selected:hover,\nbody.dark-mode .table tbody tr.table-active:hover {\n  background-color: rgba(96,165,250,0.16) !important;\n}\n\n/* Very high-specificity fallback to override other compiled styles */\nbody.dark-mode table.table tbody tr.selected,\nbody.dark-mode table.table tbody tr.selected td,\nbody.dark-mode table.table tbody tr.selected th,\nbody.dark-mode table.table tbody tr.selected td *,\nbody.dark-mode table.table tbody tr.selected th * {\n  color: #000000 !important;\n  fill: #000000 !important;\n}\n\n/* Ensure anchor/text inside selected row are black */\nbody.dark-mode table.table tbody tr.selected a,\nbody.dark-mode table.table tbody tr.selected span,\nbody.dark-mode table.table tbody tr.selected p,\nbody.dark-mode table.table tbody tr.selected div {\n  color: #000000 !important;\n}\n\n/* Additional brute-force overrides for common utility classes inside selected rows */\nbody.dark-mode table.table tbody tr.selected .text-white,\nbody.dark-mode table.table tbody tr.selected .text-muted,\nbody.dark-mode table.table tbody tr.selected .badge,\nbody.dark-mode table.table tbody tr.selected .btn,\nbody.dark-mode table.table tbody tr.selected .btn *,\nbody.dark-mode table.table tbody tr.selected .badge *,\nbody.dark-mode table.table tbody tr.selected .dropdown-toggle {\n  color: #000000 !important;\n  background-color: transparent !important;\n  -webkit-text-fill-color: #000000 !important;\n}\n\n/* Inline SVG icons inside selected rows */\nbody.dark-mode table.table tbody tr.selected svg {\n  fill: #000000 !important;\n}\n\n/* If the row is marked via .table-active class on ancestor tbody */\nbody.dark-mode table.table tbody.table-active tr,\nbody.dark-mode table.table tbody.table-active tr td,\nbody.dark-mode table.table tbody.table-active tr * {\n  color: #000000 !important;\n}\n\n/* Close (X) button visibility in dark mode */\nbody.dark-mode .btn-close,\nbody.dark-mode .close {\n  background-image: none !important;\n  width: 34px !important;\n  height: 34px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 6px !important;\n  background: transparent !important;\n  color: var(--dm-text) !important;\n  border: none !important;\n  opacity: 0.95 !important;\n}\n\nbody.dark-mode .btn-close::before,\nbody.dark-mode .close::before {\n  content: '✕' !important;\n  font-size: 16px !important;\n  color: var(--dm-text) !important;\n  line-height: 1 !important;\n}\n\nbody.dark-mode .btn-close:hover,\nbody.dark-mode .btn-close:focus,\nbody.dark-mode .close:hover,\nbody.dark-mode .close:focus {\n  background-color: rgba(255,255,255,0.06) !important;\n  color: var(--dm-text) !important;\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(96,165,250,0.10) !important;\n}\n\n/* Ensure close button in modal header aligns and contrasts */\nbody.dark-mode .modal-header .btn-close {\n  margin: 6px !important;\n}\n\n/* Explicit overrides for specific contexts to beat compiled bootstrap/public CSS */\nbody.dark-mode .modal .btn-close,\nbody.dark-mode .offcanvas .btn-close,\nbody.dark-mode .toast .btn-close,\nbody.dark-mode .alert .btn-close,\nbody.dark-mode .dropdown .btn-close,\nbody.dark-mode .btn-close.btn-close-white {\n  background-image: none !important;\n  background: transparent !important;\n  color: var(--dm-text) !important;\n  border: none !important;\n}\n\n/* If bootstrap forces an SVG background, replace it with a white SVG via data URI to ensure visibility */\nbody.dark-mode .btn-close[style],\nbody.dark-mode .modal-header .btn-close[style] {\n  background-image: none !important;\n  background: transparent !important;\n  background-size: none !important;\n  background-repeat: none !important;\n  background-position: center !important;\n}\n\n/* Ensure hover/focus remain visible */\nbody.dark-mode .btn-close:hover,\nbody.dark-mode .btn-close:focus {\n  opacity: 1 !important;\n  background-color: rgba(255,255,255,0.06) !important;\n  box-shadow: 0 0 0 4px rgba(96,165,250,0.08) !important;\n}\n\n/* Melhor contraste entre divs com bordas */\nbody.dark-mode .card,\nbody.dark-mode .panel,\nbody.dark-mode .box,\nbody.dark-mode .bordered,\nbody.dark-mode .border,\nbody.dark-mode .list-group-item,\nbody.dark-mode .form-control,\nbody.dark-mode .table,\nbody.dark-mode .table-responsive,\nbody.dark-mode .container,\nbody.dark-mode .container-fluid {\n  border: 1px solid rgba(255,255,255,0.06) !important;\n  background-color: rgba(255,255,255,0.01) !important;\n}\n\n/* Reforçar classes de borda específicas */\nbody.dark-mode .border-top,\nbody.dark-mode .border-bottom,\nbody.dark-mode .border-left,\nbody.dark-mode .border-right {\n  border-color: rgba(255,255,255,0.06) !important;\n}\n\n/* Painéis internos e containers com separação mais visível */\nbody.dark-mode .panel + .panel,\nbody.dark-mode .card + .card,\nbody.dark-mode .form-group {\n  margin-top: 12px !important;\n  margin-bottom: 12px !important;\n}\n\n/* Garantir que títulos dentro de caixas contrastem */\nbody.dark-mode .card .card-header,\nbody.dark-mode .panel .panel-heading {\n  background-color: rgba(255,255,255,0.012) !important;\n  color: var(--dm-text) !important;\n  border-bottom: 1px solid rgba(255,255,255,0.04) !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
